import { render, staticRenderFns } from "./DrawingCard.vue?vue&type=template&id=2ed88c37&scoped=true&"
import script from "./DrawingCard.vue?vue&type=script&lang=js&"
export * from "./DrawingCard.vue?vue&type=script&lang=js&"
import style0 from "./DrawingCard.vue?vue&type=style&index=0&id=2ed88c37&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed88c37",
  null
  
)

export default component.exports